import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ButtonComp } from "../../../ui/input/Button";
import { setScene } from "../../../ui/scene";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { Main } from "../../scenes/main";

export const DeathModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  floodFill(C.display, C.bounds, Colors.BLACK);
  C.handlers.keypress = (key: string) => {
    if (key === "Enter") {
      return false;
    }
    return true;
  };

  return [
    createElement(
      TextType,
      { x: 1, y: 0, w: C.bounds.w - 2, h: 1 },
      { title: "DEFEAT", align: ALIGN_TYPE.center }
    ),
    createElement(
      TextType,
      { x: 1, y: 1, w: C.bounds.w - 2, h: 1 },
      {
        title:
          "Unwaivering was your faith, but it wasn't enough to overcome despair. Your wounds are fatal.",
      }
    ),
    createElement(
      ButtonComp,
      { x: 1, y: C.bounds.h - 2, w: C.bounds.w - 2, h: 1 },
      {
        title: "(Enter) Restart",
        keys: ["Escape", "Enter"],
        onClick: () => {
          closeModal();
          setScene(new Main());
        },
      }
    ),
  ];
};
